import { render, staticRenderFns } from "./PublicationsPage.vue?vue&type=template&id=2bfdd5f5&scoped=true"
import script from "./PublicationsPage.vue?vue&type=script&lang=js"
export * from "./PublicationsPage.vue?vue&type=script&lang=js"
import style0 from "./PublicationsPage.vue?vue&type=style&index=0&id=2bfdd5f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfdd5f5",
  null
  
)

export default component.exports